// Copy for the onboarding Next button while a stage is saving. It gets more
// reassuring the longer the save takes so clients don't refresh mid-save.
// `afterMs` must start at 0 and increase; NextButton times them with CSS.

export const SAVING_MESSAGES: { afterMs: number; text: string }[] = [
  { afterMs: 0, text: 'Saving your answers… ✨' },
  { afterMs: 3000, text: 'Still on it, no need to refresh! 💪' },
  { afterMs: 7000, text: 'Remi is double-checking everything… 🧐' },
  { afterMs: 12000, text: 'Good things take a sec. Hang tight! ⏳' },
  { afterMs: 20000, text: 'Almost there. Thanks for your patience! 🙏' },
];

export const SAVE_NOT_CONFIRMED_MESSAGE =
  "Hmm, we couldn't confirm that saved. Your answers are still here, so give it another try.";
